/* ============================================================
   MAQAM OF SCENTS — theme.js
   ============================================================ */
(function () {
  'use strict';

  const cfg = window.MAQAM || { moneyFormat: '{{amount}}', cartUrl: '/cart', freeShipThreshold: 0, routes: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SCROLL BUS ----------
     Listens in the capture phase on `document` so it still fires if any
     ancestor (body, a wrapper) ends up being the scroll container, which
     plain `window.addEventListener('scroll')` would miss. */
  const scrollSubs = [];
  let scrollTicking = false;
  function runScrollSubs() { scrollTicking = false; scrollSubs.forEach(fn => { try { fn(); } catch (e) {} }); }
  function scheduleScroll() { if (!scrollTicking) { scrollTicking = true; requestAnimationFrame(runScrollSubs); } }
  function onScroll(fn) { scrollSubs.push(fn); fn(); }
  document.addEventListener('scroll', scheduleScroll, { passive: true, capture: true });
  window.addEventListener('resize', scheduleScroll, { passive: true });
  window.addEventListener('orientationchange', scheduleScroll, { passive: true });

  /* Mirrors Shopify's money filter so drawer totals match the page exactly. */
  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const dot2 = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const dot0 = Math.round(value).toLocaleString('en-US');
    const comma2 = dot2.replace(/,/g, '|').replace('.', ',').replace(/\|/g, '.');
    const comma0 = dot0.replace(/,/g, '.');
    return String(cfg.moneyFormat)
      .replace(/\{\{\s*amount\s*\}\}/g, dot2)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dot0)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma2)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, comma0)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, dot2.replace(/,/g, "'"))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, dot0.replace(/,/g, ' '))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, comma2.replace(/\./g, ' '));
  }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- ANNOUNCEMENT ROTATOR ---------- */
  (function () {
    const bar = $('[data-announce]');
    if (!bar) return;
    const items = $$('.announce__item', bar);
    if (items.length < 2 || reduceMotion) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  })();

  /* ---------- HEADER ---------- */
  const header = $('.header');
  if (header) onScroll(() => { header.classList.toggle('is-scrolled', window.scrollY > 30); });

  /* ---------- MOBILE NAV ---------- */
  const burger = $('.burger');
  const mobileNav = $('.mobile-nav');
  if (burger && mobileNav) {
    const setNav = (open) => {
      mobileNav.classList.toggle('is-open', open);
      if (header) header.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('no-scroll', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    };
    burger.addEventListener('click', () => setNav(!mobileNav.classList.contains('is-open')));
    $$('.mobile-nav a').forEach(a => a.addEventListener('click', () => setNav(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) setNav(false); });
  }

  /* ---------- HERO VIDEO (desktop only, after paint) ---------- */
  (function () {
    const v = $('.hero__video');
    if (!v || reduceMotion) return;
    if (window.matchMedia('(max-width: 900px)').matches) return;
    if (navigator.connection && navigator.connection.saveData) return;
    const load = () => {
      v.src = v.dataset.src;
      v.addEventListener('canplay', () => v.classList.add('is-ready'), { once: true });
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };
    if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 2500 });
    else window.addEventListener('load', load);
  })();

  /* ---------- SCROLL REVEAL ----------
     Decorative only. Three layers of safety so content can never be
     left invisible: viewport check on scroll, IntersectionObserver,
     and an unconditional reveal-all shortly after load. */
  (function () {
    const els = () => $$('[data-reveal]:not(.is-in)');
    const revealAll = () => $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
    if (reduceMotion) { revealAll(); return; }

    const check = () => {
      const h = window.innerHeight || document.documentElement.clientHeight;
      els().forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < h * 0.94 && r.bottom > 0) el.classList.add('is-in');
      });
    };
    onScroll(check);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      els().forEach(el => io.observe(el));
    }

    setTimeout(check, 200);
    window.addEventListener('load', () => { setTimeout(check, 100); setTimeout(revealAll, 2500); });
    setTimeout(revealAll, 4000);
  })();

  /* ---------- ACCORDIONS (FAQ + PDP) ---------- */
  function initAccordion(qSel, itemSel, aSel, exclusive) {
    $$(qSel).forEach(q => {
      const item = q.closest(itemSel);
      const ans = $(aSel, item);
      if (!ans) return;
      if (item.classList.contains('is-open')) { ans.style.maxHeight = ans.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
      q.addEventListener('click', () => {
        const willOpen = !item.classList.contains('is-open');
        if (exclusive && willOpen) {
          $$(itemSel, item.parentElement).forEach(other => {
            if (other === item) return;
            other.classList.remove('is-open');
            const oa = $(aSel, other); if (oa) oa.style.maxHeight = 0;
            const oq = $(qSel, other); if (oq) oq.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', willOpen);
        q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        ans.style.maxHeight = willOpen ? ans.scrollHeight + 'px' : 0;
      });
    });
  }
  initAccordion('.faq__q', '.faq__item', '.faq__a', true);
  initAccordion('.acc__q', '.acc__item', '.acc__a', false);
  window.addEventListener('resize', () => {
    $$('.acc__item.is-open .acc__a, .faq__item.is-open .faq__a').forEach(a => { a.style.maxHeight = a.scrollHeight + 'px'; });
  }, { passive: true });

  /* ---------- MAP FACADE ---------- */
  $$('.map-facade').forEach(btn => {
    btn.addEventListener('click', () => {
      const f = document.createElement('iframe');
      f.title = 'Our atelier location';
      f.loading = 'lazy';
      f.referrerPolicy = 'no-referrer-when-downgrade';
      f.src = btn.dataset.mapSrc;
      btn.replaceWith(f);
    });
  });

  /* ---------- PDP GALLERY ---------- */
  const mainImg = $('.pdp__main-img img');
  if (mainImg) {
    const thumbs = $$('.pdp__thumbs button');
    thumbs.forEach((btn, idx) => {
      btn.addEventListener('click', () => {
        thumbs.forEach(b => { b.classList.remove('is-active'); b.removeAttribute('aria-current'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
        const src = btn.dataset.full || ($('img', btn) || {}).src;
        if (!src) return;
        mainImg.style.opacity = 0;
        const pre = new Image();
        pre.onload = () => { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.style.opacity = 1; };
        pre.src = src;
      });
      btn.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const next = thumbs[(idx + (e.key === 'ArrowRight' ? 1 : thumbs.length - 1)) % thumbs.length];
        next.focus(); next.click();
      });
    });
  }

  /* ---------- STICKY ADD TO CART ----------
     Appears once the real Add-to-Cart row has scrolled above the viewport. */
  (function () {
    const sticky = $('.sticky-atc');
    const atcRow = $('.pdp__buy');
    if (!sticky || !atcRow) return;
    const update = () => {
      const show = atcRow.getBoundingClientRect().bottom < 0;
      if (show === sticky.classList.contains('is-visible')) return;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    onScroll(update);
    setInterval(update, 400);
  })();

  /* ---------- QTY STEPPERS ---------- */
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    const wrap = (dec || inc).closest('.qty');
    const input = $('input', wrap);
    let v = parseInt(input.value, 10) || 1;
    v = inc ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- VARIANT PICKER ---------- */
  (function () {
    const data = window.MAQAM_PRODUCT;
    const form = $('#pdp-form');
    if (!data || !form) return;
    const selected = {};
    $$('.pdp__swatch.is-active', form).forEach(b => { selected[b.dataset.opt] = b.dataset.val; });
    $$('.pdp__swatch', form).forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.opt;
        $$('.pdp__swatch[data-opt="' + pos + '"]', form).forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        selected[pos] = btn.dataset.val;
        const match = data.variants.find(v => data.options.every((_, i) => v.options[i] === selected[String(i + 1)]));
        if (!match) return;
        form.querySelector('[name="id"]').value = match.id;
        $$('[data-price]').forEach(el => { el.textContent = formatMoney(match.price); });
        const stickyBtn = $('.sticky-atc [data-add-id]');
        if (stickyBtn) stickyBtn.dataset.addId = match.id;
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        if (history.replaceState) {
          const u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          history.replaceState({}, '', u);
        }
      });
    });
  })();

  /* ============================================================
     CART DRAWER
     ============================================================ */
  const drawer = $('.cart-drawer');
  const overlay = $('.drawer-overlay');
  let lastFocus = null;
  let cartLoaded = false;
  let scrollLock = 0;

  function focusables() { return $$('a[href], button:not([disabled]), input, select', drawer).filter(el => el.offsetParent !== null); }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    scrollLock = window.scrollY;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    if (!cartLoaded) { cartLoaded = true; refreshCart(false); }
    const f = focusables();
    if (f.length) f[0].focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    window.scrollTo(0, scrollLock);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.maqamOpenCart = openDrawer;

  $$('[data-cart-toggle]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables();
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function renderCart(cart) {
    if (!drawer || !cart || typeof cart.item_count === 'undefined') return;
    const body = $('.cart-drawer__body', drawer);
    const foot = $('.cart-drawer__foot', drawer);
    $$('.cart-count').forEach(c => { c.textContent = cart.item_count; c.hidden = !cart.item_count; });

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Your collection is empty</p><a href="' + (cfg.routes.all_products || '/collections/all') + '" class="btn btn--ghost">Discover Fragrances</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (item) {
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-line__variant">' + esc(item.variant_title) + '</div>' : '';
      const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      const name = esc(String(item.product_title).split(' — ')[0]);
      return '<div class="cart-line" data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '" class="cart-line__imglink"><img class="cart-line__img" src="' + esc(img) + '" alt="" width="78" height="98" loading="lazy"></a>' +
        '<div class="cart-line__info">' +
          '<div class="cart-line__title"><a href="' + esc(item.url) + '">' + name + '</a></div>' + variant +
          '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-line__bottom">' +
            '<div class="qty"><button type="button" data-qty-dec aria-label="Decrease quantity">&minus;</button>' +
            '<input type="text" value="' + item.quantity + '" data-line-key="' + esc(item.key) + '" inputmode="numeric" aria-label="Quantity"><button type="button" data-qty-inc aria-label="Increase quantity">&plus;</button></div>' +
            '<button type="button" class="cart-line__remove" data-remove="' + esc(item.key) + '">Remove</button>' +
          '</div>' +
        '</div></div>';
    }).join('');

    if (foot) {
      const sub = $('[data-subtotal]', foot);
      if (sub) sub.textContent = formatMoney(cart.total_price);
      const threshold = cfg.freeShipThreshold;
      const meter = $('.ship-bar i', foot);
      const note = $('[data-ship-note]', foot);
      if (threshold > 0 && meter && note) {
        const pct = Math.min(100, (cart.total_price / threshold) * 100);
        meter.style.width = pct + '%';
        const remain = threshold - cart.total_price;
        note.innerHTML = remain > 0
          ? 'You are <b>' + formatMoney(remain) + '</b> away from free delivery.'
          : '<b>Free delivery unlocked</b> — enjoy.';
      }
      const up = $('.cart-upsell', foot);
      if (up && up.dataset.upsellId) {
        up.hidden = cart.items.some(i => String(i.product_id) === up.dataset.upsellId);
      }
    }
    rebindLines();
  }

  function rebindLines() {
    $$('[data-remove]', drawer).forEach(b => b.addEventListener('click', () => changeLine(b.dataset.remove, 0)));
    $$('[data-line-key]', drawer).forEach(inp => inp.addEventListener('change', () => {
      changeLine(inp.dataset.lineKey, Math.max(0, parseInt(inp.value, 10) || 0));
    }));
  }

  function changeLine(key, qty) {
    drawer.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(r => r.json()).then(renderCart)
      .catch(() => {})
      .then(() => drawer.classList.remove('is-busy'));
  }

  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json()).then(c => { cartLoaded = true; renderCart(c); if (open) openDrawer(); })
      .catch(() => {});
  }

  function addToCart(items, btn) {
    const payload = Array.isArray(items) ? { items: items } : { items: [items] };
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(r => r.json().then(d => ({ ok: r.ok, d: d }))).then(res => {
      if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart');
      cartLoaded = true;
      return refreshCart(true);
    }).then(() => {
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = btn.dataset.label; btn.disabled = false; }, 1500); }
    }).catch((err) => {
      if (btn) { btn.textContent = btn.dataset.label; btn.disabled = false; }
      const host = $('#pdp-form') || document.body;
      let n = $('.form-error', host);
      if (!n) { n = document.createElement('p'); n.className = 'form-error'; n.setAttribute('role', 'alert'); host.appendChild(n); }
      n.textContent = err.message;
    });
  }
  window.maqamAddToCart = (id, qty, btn) => addToCart({ id: id, quantity: qty || 1 }, btn);

  document.addEventListener('click', (e) => {
    const one = e.target.closest('[data-add-id]');
    if (one) {
      e.preventDefault();
      addToCart({ id: one.dataset.addId, quantity: parseInt(one.dataset.addQty || '1', 10) }, one);
      return;
    }
    const many = e.target.closest('[data-add-multi]');
    if (many) {
      e.preventDefault();
      const ids = many.dataset.addMulti.split(',').filter(Boolean);
      addToCart(ids.map(id => ({ id: id, quantity: 1 })), many);
    }
  });

  const pdpForm = $('#pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const id = $('[name="id"]', pdpForm).value;
      const qty = parseInt(($('[name="quantity"]', pdpForm) || {}).value || '1', 10);
      addToCart({ id: id, quantity: qty }, $('[type="submit"]', pdpForm));
    });
  }

  /* ---------- COLLECTION SORT ---------- */
  const sortEl = $('[data-sort]');
  if (sortEl) sortEl.addEventListener('change', () => { window.location.href = sortEl.value; });

})();
